var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('div',[_c('img',{staticClass:"img-logo",attrs:{"src":require("@/assets/logo_seculos.png"),"height":"52"}})])])}]

export { render, staticRenderFns }